(() => {
  const ROTATION_WINDOW_MS = 3 * 24 * 60 * 60 * 1000;

  const hash = (value) => {
    let result = 2166136261;

    for (let index = 0; index < value.length; index += 1) {
      result ^= value.charCodeAt(index);
      result = Math.imul(result, 16777619);
    }

    return result >>> 0;
  };

  const createRandom = (seed) => () => {
    seed = (Math.imul(seed, 1664525) + 1013904223) >>> 0;
    return seed / 4294967296;
  };

  const shuffle = (items, random) => {
    for (let index = items.length - 1; index > 0; index -= 1) {
      const swapIndex = Math.floor(random() * (index + 1));
      [items[index], items[swapIndex]] = [items[swapIndex], items[index]];
    }

    return items;
  };

  const selectFeaturedProducts = (section) => {
    const grid = section.querySelector('.product-grid[data-homepage-products-to-show]');

    if (!grid) {
      return;
    }

    const productsToShow = Number.parseInt(grid.dataset.homepageProductsToShow, 10);
    const candidates = [...grid.querySelectorAll(':scope > [data-homepage-product]')];

    if (!Number.isInteger(productsToShow) || productsToShow < 1 || candidates.length === 0) {
      return;
    }

    const ranked = candidates
      .map((item, index) => ({
        item,
        index,
        soldCount: Number.parseFloat(item.dataset.homepageSoldCount) || 0,
      }))
      .sort((left, right) => right.soldCount - left.soldCount || left.index - right.index);

    let selected = ranked;

    if (ranked.length > productsToShow) {
      const priorityCount = Math.min(2, productsToShow);
      const priority = ranked.slice(0, priorityCount);
      const rotating = ranked.slice(priorityCount);
      const rotationWindow = Math.floor(Date.now() / ROTATION_WINDOW_MS);
      const random = createRandom(hash(`${rotationWindow}:${section.id}`));

      selected = priority.concat(shuffle(rotating, random).slice(0, productsToShow - priorityCount));
    }

    const selectedItems = selected.slice(0, productsToShow).map(({ item }) => item);
    const selectedSet = new Set(selectedItems);
    const orderedItems = selectedItems.concat(candidates.filter((item) => !selectedSet.has(item)));

    grid.append(...orderedItems);
    orderedItems.forEach((item, index) => {
      item.hidden = index >= productsToShow;
      item.style.setProperty('--animation-order', index + 1);
    });
  };

  const initialise = (root = document) => {
    const sections = root instanceof Element && root.matches('[data-homepage-featured-products]')
      ? [root]
      : [...root.querySelectorAll('[data-homepage-featured-products]')];

    sections.forEach((section) => {
      if (section.dataset.homepageBackToTopReady === 'true') {
        return;
      }

      const backToTop = section.querySelector('[data-homepage-back-to-top]');

      if (!backToTop) {
        return;
      }

      selectFeaturedProducts(section);

      const updateBackToTop = () => {
        backToTop.hidden = window.scrollY < 480;
      };

      backToTop.addEventListener('click', (event) => {
        event.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      });

      window.addEventListener('scroll', updateBackToTop, { passive: true });
      updateBackToTop();
      section.dataset.homepageBackToTopReady = 'true';
    });
  };

  document.addEventListener('DOMContentLoaded', () => initialise());
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
